import { render } from "./CartFooter.vue?vue&type=template&id=5a058704&scoped=true"
import script from "./CartFooter.vue?vue&type=script&lang=js"
export * from "./CartFooter.vue?vue&type=script&lang=js"

import "./CartFooter.vue?vue&type=style&index=0&id=5a058704&scoped=true&lang=css"

import exportComponent from "/Users/songj/GitHubCodes/cart-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a058704"]])

export default __exports__